import { CommerceApi, Commerce } from '../models';

export function mapCommerceApiToModel(commerceApi: CommerceApi): Commerce {
  return {
    id: commerceApi.id,
    name: commerceApi.name,
    businessName: commerceApi.businessName,
    taxNumber: commerceApi.taxNumber,
    status: commerceApi.status,
    addressId: commerceApi.addressId,
    externalId: commerceApi.externalId,
    apiCode: commerceApi.apiCode ?? null,
    businessKey: commerceApi.businessKey,
    logo: commerceApi.logo,
    businessType: commerceApi.businessType,
    url: commerceApi.url,
    email: commerceApi.email,
    phone: commerceApi.phone ?? null,
    enabled: commerceApi.enabled,
    commerceGroupId: commerceApi.commerceGroupId ?? null,
    address: commerceApi.address,
    createdAt: commerceApi.createdAt,
    updatedAt: commerceApi.updatedAt,
  };
}
